module.exports = __webpack_public_path__ + "static/Team2-2728b48f5d7cd72920b0b218354474c9.png";